import { fm } from 'Components/FormatMessage';
import { ftd } from 'neuro-schemas';
import * as React from 'react';

import type { FTDResult, TFTDYesNoUnknown } from 'neuro-schemas/ftd';

const {
  utils: { resultPicker },
} = ftd;

const rows1: FTDResult[] = [
  'criteriaForCertainFTDFulfilled',
  'criteriaForProbableFTDFulfilled',
  'criteriaForPossibleFTDFulfilled',
];

const rows2: FTDResult[] = ['coreCriteriaForFTDFulfilled', 'exclusionCriteriaForFTDFulfilled'];

const secondaryCriteriaToLocalizationSuffixMap: Record<TFTDYesNoUnknown, string> = {
  yes: 'Fulfilled',
  no: 'NotFulfilled',
  unknown: 'Unknown',
};

const FTDDiagnosticCriteriaHistory = ({ d }: IOwnProps): React.JSX.Element => {
  const fulfilledCriteria = rows1.find(row => resultPicker(d, row) === 'yes');

  return (
    <React.Fragment>
      {!!fulfilledCriteria ? (
        <div>{fm(`diagnosis.ftd.summary.${fulfilledCriteria}`)}</div>
      ) : (
        rows2.map((row, i) => (
          <div key={row}>
            {fm(
              `diagnosis.ftd.summary.${row.split('ForFTD')[0]}${secondaryCriteriaToLocalizationSuffixMap[resultPicker(d, row)]}`,
            )}
          </div>
        ))
      )}
    </React.Fragment>
  );
};

interface IOwnProps {
  d: IDocumentWithTypeV2<'ftd'>;
}

export default FTDDiagnosticCriteriaHistory;
